import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightRoseGold = () => {
  return (
    <div className="blogWhat-content">
      <h5>5. Rose Gold & Pastel Pink Highlights 🌸</h5>
      <p>
        For those who love a touch of fun and femininity, rose gold and pastel
        pink highlights are the perfect pick. These dreamy hair highlights for
        women are soft yet playful, adding a trendy and creative twist to your
        hairstyle.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Unique and eye-catching{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Soft and romantic
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Works well with blonde and light
            brown hair
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightRoseGold;
